import add from './add-outline.svg'
import food from './location-food.svg'
import task from './calendar.svg'
import money from './wallet.svg'
import back from './arrow-outline-left.svg'
import save from './save-disk.svg'
import user from './user.svg'
import remove from './trash.svg'
import styles from './Images.module.css'
import addEventUser from './add-outline.svg'
import bell from './notifications-outline.svg'
import alertBell from './notifications.svg'
import info from'./information-outline.svg'
import home from './home.svg'
import reload from './reload.svg'
import search from './search.svg'
import filter from './filter.svg'
import up from './arrow-thick-up.svg'
import down from './arrow-thick-down.svg'

export const AddIcon = () => (
    <img
        src={add}
        alt="Add"
        className={styles.buttonIcon}
  />
)
export const FoodIcon = () => (
    <img
        src={food}
        alt="Food"
        className={styles.buttonIcon}
  />
)
export const TaskIcon = () => (
    <img
        src={task}
        alt="Task"
        className={styles.buttonIcon}
  />
)
export const MoneyIcon = () => (
    <img
        src={money}
        alt="Money"
        className={styles.buttonIcon}
  />
)
export const BackIcon = () => (
    <img
        src={back}
        alt="Back"
        className={styles.buttonIcon}
  />
)
export const SaveIcon = () => (
    <img
        src={save}
        alt="Save"
        className={styles.buttonIcon}
  />
)
export const UserIcon = () => (
  <img
      src={user}
      alt="User"
      className={styles.buttonIcon}
/>
)
export const DeleteIcon = () => (
  <img
      src={remove}
      alt="Delete"
      className={styles.buttonIcon}
/>
)
export const AddEventUserIcon = () => (
  <img
      src={addEventUser}
      alt="AddEventUser"
      className={styles.buttonIcon}
/>
)
export const BellIcon = () => (
  <img 
      color='white'
      src={bell}
      alt="BellIcon"
      className={styles.buttonIcon}
      />
)
export const AlertBellIcon = () => (
  <img 
      src={alertBell}
      alt="BellIcon"
      className={styles.buttonIcon}
      />
)
export const InformationIcon = () => (
    <img 
    src={info}
    alt="InformationIcon"
    className={styles.buttonIcon}
    />
)
export const HomeIcon = () => (
    <img
      src={home}
      alt="Home Icon"
      className={styles.buttonIcon}
      />
)
export const ReloadIcon = () => (
  <img
    src={reload}
    alt="reload icon"
    className={styles.buttonIcon}
    />
)
export const SearchIcon = () => (
  <img  
    src={search}
    alt="magnifying glass"
    className={styles.buttonIcon}
    />
)
export const FilterIcon = () => (
  <img 
    src={filter}
    alt="Filter funnel"
    className={styles.buttonIcon}
    />  
)
export const UpIcon = () => (
  <img 
    src={up}
    alt="Up arrow"
    className={styles.buttonIcon}
    />  
)
export const DownIcon = () => (
  <img 
    src={down}
    alt="down icon"
    className={styles.buttonIcon}
    />  
)